import styled from 'styled-components';
import * as theme from '@zero/design-tokens/build/js/variables';

export const A = styled.a`
    color: ${theme.ZrColorLinkActive}!important;
    text-decoration: none!important;
    &:visited {
        color:${theme.ZrColorLinkVisited}!important;
    }
    &:hover {
        text-decoration: underline!important    ;
    }
    
`
